export const IMAGE_REGEX = /\.(jpeg|jpg|gif|png)$/
export const NUMBER_REGEX = /^\d+$/
